import React from 'react';
import { connect } from 'react-redux';
import { LoadingIcon } from '_components';
import { PatientTabs, PatientSpecificTabs, PatientContent } from 'PatientCareCenter';
import styles from './PatientCareCenter.module.css';

class PatientCareCenter extends React.Component {
    render() {
        if (this.props.patientCount > 0) {
            return (
                <div className={styles.pcc_content}>
                    <PatientTabs />
                    {!this.props.loading &&
                        <>
                            <PatientSpecificTabs />
                            <PatientContent />
                        </>
                    }
                    {this.props.loading &&
                        <div className={styles.loading_div}>
                            <br />
                            <label>Loading...</label>
                            <br /><br />
                            <LoadingIcon size='large' />
                        </div>
                    }
                </div>
            );
        } else {
            return (<div style={{ width: '100%', textAlign: 'center', paddingTop: '40px' }}><i>No open patients.</i></div>);
        }
    }
}


function mapStateToProps(state) {
    return {
        patientCount: Object.keys(state.entities.patients).length,
        loading: state.ui.patients.selectedPtno && state.entities.patients[state.ui.patients.selectedPtno] ?
            state.entities.patients[state.ui.patients.selectedPtno].loading : true
    };
}

const connectedPatientCareCenter = connect(mapStateToProps)(PatientCareCenter);
export { connectedPatientCareCenter as PatientCareCenter };
